module.exports = __webpack_public_path__ + "img/payment_channels.7adcc425.svg";